import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { WebApiService } from './web-api.service';
import { ApiUrlConstants } from '../common/ApiUrlConstants';
import { ComplianceExemption } from '../models/user.model';

@Injectable({ providedIn: 'root' })
export class ComplianceExemptionService {
  private readonly mineSubject = new BehaviorSubject<ComplianceExemption | null>(null);
  readonly mine$ = this.mineSubject.asObservable();
  private readonly changedSubject = new Subject<void>();
  /** Fires after any admin change, so the alert/card can re-load. */
  readonly changed$ = this.changedSubject.asObservable();

  constructor(private webApi: WebApiService) {}

  /** The signed-in user's company exemption. Never rejects: failure = no exemption. */
  async fetchMine(): Promise<ComplianceExemption | null> {
    try {
      // getRequest1 returns res.data unchanged ({ exemption }).
      const resp: any = await this.webApi.getRequest1<any>(ApiUrlConstants.complianceExemptionMe);
      const ex = (resp?.exemption ?? null) as ComplianceExemption | null;
      this.mineSubject.next(ex);
      return ex;
    } catch {
      this.mineSubject.next(null);
      return null;
    }
  }

  clearMine(): void { this.mineSubject.next(null); }

  getByUser(userId: number): Promise<any> {
    return this.webApi.getRequest1<any>(`${ApiUrlConstants.complianceExemptionByUser}/${userId}`);
  }
  endedTrials(): Promise<any> {
    return this.webApi.getRequest1<any>(ApiUrlConstants.complianceExemptionEndedTrials);
  }
  async upsert(body: any): Promise<any> {
    const r = await this.webApi.postRequest<any>(ApiUrlConstants.complianceExemptionUpsert, body);
    this.changedSubject.next();
    return r;
  }
  async disable(body: any): Promise<any> {
    const r = await this.webApi.postRequest<any>(ApiUrlConstants.complianceExemptionDisable, body);
    this.changedSubject.next();
    return r;
  }
  async restoreGates(body: any): Promise<any> {
    const r = await this.webApi.postRequest<any>(ApiUrlConstants.complianceExemptionRestoreGates, body);
    this.changedSubject.next();
    return r;
  }
}
